/**
 * Insert a filings row, dropping optional columns if PostgREST schema cache
 * doesn't know about them yet (migrations not applied).
 */
export async function insertFilingWithFallback(supabase, payload) {
  const optionalKeys = [
    'source',
    'nwra_document_id',
    'custom_date',
    'tag',
    'document_type',
    'folder_id',
  ];

  let attempt = { ...payload };
  let lastError = null;

  for (let i = 0; i <= optionalKeys.length; i++) {
    const { data, error } = await supabase
      .from('filings')
      .insert(attempt)
      .select('*')
      .single();

    if (!error) {
      return { data, error: null };
    }

    lastError = error;
    const msg = error.message || '';
    const missingOptional = optionalKeys.find(
      (key) =>
        attempt[key] !== undefined &&
        new RegExp(`${key}|schema cache|Could not find`, 'i').test(msg)
    );

    if (!missingOptional && !/schema cache|Could not find the .* column/i.test(msg)) {
      return { data: null, error };
    }

    // Drop the named missing column, or peel optional fields one by one
    if (missingOptional) {
      const next = { ...attempt };
      delete next[missingOptional];
      attempt = next;
    } else {
      const next = { ...attempt };
      const toDrop = optionalKeys.find((k) => k in next);
      if (!toDrop) return { data: null, error };
      delete next[toDrop];
      attempt = next;
    }
  }

  return { data: null, error: lastError };
}
